import IconButton from '@mui/material/IconButton';
import { ReactElement } from 'react';

import archiveIcon from '~/ui/assets/images/archiveIcon.svg';
import editIcon from '~/ui/assets/images/editGrey.svg';

import styles from './RowActions.module.scss';

interface IRowActionsProps {
  subject: string;
  onEdit: () => void;
  onArchive?: () => void;
}

const RowActions = ({ subject, onEdit, onArchive }: IRowActionsProps): ReactElement => (
  <div className={styles.rowActions}>
    <IconButton aria-label={`Edit ${subject}`} size="small" onClick={onEdit}>
      <img src={editIcon} alt="" />
    </IconButton>
    {onArchive && (
      <IconButton aria-label={`Archive ${subject}`} size="small" onClick={onArchive}>
        <img src={archiveIcon} alt="" />
      </IconButton>
    )}
  </div>
);

export default RowActions;
